import * as yup from 'yup';

const optionsSchema = yup.object().shape({
 description: yup.string().required('Campo obrigatório'),
 isPrerequisite: yup.mixed().oneOf(['Sim', 'Não']).nullable(),
});

export const schema = {
 code: yup.string().required('Campo obrigatório'),
 title: yup.string().required('Campo obrigatório'),
 type: yup
  .mixed()
  .oneOf(
   ['multi_choice', 'text', 'multiple_choice', 'percentage', 'number', 'money', 'grid'],
   'Selecione o tipo da pergunta'
  )
  .required('Selecione o tipo da pergunta'),
 // EG-41 — CA03: classificar é opcional, mas pela metade não vale. Escolhido o
 // pilar, o tema passa a ser obrigatório. Tema sozinho é aceito: o tema já
 // pertence a um pilar no catálogo, então o backend deriva o par completo.
 id_pillar: yup.number().nullable().optional(),
 id_theme: yup
  .number()
  .nullable()
  .when('id_pillar', {
   is: (idPillar) => Boolean(idPillar),
   then: (esquema) =>
    esquema.required('O campo Tema é obrigatório quando um Pilar é selecionado'),
   otherwise: (esquema) => esquema.optional(),
  }),
 previousYears: yup.mixed().oneOf(['Sim', 'Não']).default('Não'),
 isRequired: yup.mixed().oneOf(['Sim', 'Não']).default('Não'),
 requestFiles: yup.mixed().oneOf(['Sim', 'Não']).default('Não'),
 requestImages: yup.mixed().oneOf(['Sim', 'Não']).default('Não'),
 hasHelper: yup.mixed().oneOf(['Sim', 'Não']).default('Não'),
 hasSum: yup.mixed().oneOf(['Sim', 'Não']).default('Não'),
 hasAverage: yup.mixed().oneOf(['Sim', 'Não']).default('Não'),
 helper: yup
  .object({
   description: yup.string(),
   url_video: yup.string(),
  })
  .when('hasHelper', {
   is: (val) => val === 'Sim',
   then: (schema) => schema.required(),
   otherwise: (schema) => schema.optional(),
  }),
 options: yup
  .array()
  .of(optionsSchema)
  .when('type', {
   is: (val) => val === 'multi_choice' || val === 'multiple_choice',
   then: (schema) => schema.min(1, 'Minimum of 1 field'),
   otherwise: (schema) => schema.min(0),
  }),
 isCertified: yup.mixed().when('type', {
  is: (val) => val === 'checkbox',
  then: (schema) =>
   schema.oneOf(['Sim', 'Não'], 'Select a valid option').required('Campo obrigatório'),
  otherwise: (schema) => schema.optional(),
 }),
};

export const templateSchema = yup.object().shape({
 name: yup.string().required('Digite o nome do template'),
 templateCode: yup.string().required('Digite o código'),
 form: yup
  .array()
  .of(yup.object().shape(schema))
  .required('Must have fields')
  .min(1, 'Minimum of 1 field'),
});
